import React from 'react';
import { Paper, PaperProps } from '@mui/material';

const SectionPaper: React.FC<PaperProps> = ({ children, ...props }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: 1.5,
      ...props.sx
    }}
    {...props}
  >
    {children}
  </Paper>
);

export default SectionPaper;
